import { Suspense } from "react";
import { Await, useLoaderData, defer } from "react-router-dom";
import Loader from "../components/Modals/Loader";
import api from "../storage/api";
import DealsMain from "./DealsMain";

const DealsPage = () => {
  const { events } = useLoaderData();

  return (
    <Suspense fallback={<Loader />}>
      <Await resolve={events}>
        {(loadedContent) => {
          return <DealsMain content={loadedContent} />;
        }}
      </Await>
    </Suspense>
  );
};

export default DealsPage;

async function loadDeals(params) {
  const response = await fetch(api.apiPath + "&path=deals&server=" + params.server);

  if (!response.ok) {
    alert("Произошла ошибка при загрузке данных...");
  } else {
    return response.json();
  }
}

export function loader({params}) {
  return defer({
    events: loadDeals(params),
  });
}
